import { EncField, Encoding } from '@mode-vegas/vegas';
import { createAction, props } from '@ngrx/store';

export const openModal = createAction(
  '[ViewDataModal] OpenModal',
  props<{
    encoding: Encoding;
    seriesDetail?: EncField[];
    queryToken: string;
    title: string;
  }>()
);
export const closeModal = createAction('[ViewDataModal] CloseModal');
export const setOffset = createAction('[ViewDataModal] SetOffset', props<{ offset: number }>());

export type Union = ReturnType<typeof openModal> | ReturnType<typeof closeModal> | ReturnType<typeof setOffset>;
